<template>
    <div class="max">
        <b-row>
            <b-col cols="12" md="7">
                <ValidationObserver ref="formModalValidate">
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('period')">
                                <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                                    <semesters-selectbox v-model="formData.semester_id"
                                        :validate-error="errors[0]"></semesters-selectbox>
                                </ValidationProvider>
                            </b-form-group>
                            <b-form-group :label="$t('course')" class="mb-1">
                                <ValidationProvider name="course_id" rules="required" v-slot="{ errors }">
                                    <course-auto-complete v-model="formData.course_id"
                                        :validate-error="errors[0]"></course-auto-complete>
                                </ValidationProvider>
                            </b-form-group>
                            <div class="border rounded p-3 bg-light" v-if="courseCredits.credit != null">
                                <div class="row">
                                    <div class="col-6">{{ $t('credit') }}:</div>
                                    <div class="col-6">{{ courseCredits.credit }}</div>
                                    <div class="col-6">{{ courseCredits.ects }}</div>
                                </div>
                            </div>
                            <b-form-group :label="$t('status')">
                                <ValidationProvider name="section" rules="required" v-slot="{ errors }">
                                  <parameter-selectbox code="section_statuses" sort="rank" v-model="formData.status" :validate-error="errors[0]"></parameter-selectbox>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="8">
                            <label>{{ $t('section_information') }}</label>
                            <div class="border p-4 rounded-sm">
                                <b-row>
<!--                                    <b-col>-->
<!--                                        <b-form-group :label="$t('section_type')">-->
<!--                                            <ValidationProvider name="type" rules="required" v-slot="{ errors }">-->
<!--                                                <section-type v-model="formData.type" @changedValue="setSectionMinMax"-->
<!--                                                    :validate-error="errors[0]"-->
<!--                                                    :disabled="formData.course_id == null ? true : false"></section-type>-->
<!--                                            </ValidationProvider>-->
<!--                                        </b-form-group>-->
<!--                                    </b-col>-->
                                    <b-col>
                                        <b-form-group :label="$t('section')">
                                            <ValidationProvider name="section" rules="required" v-slot="{ errors }">
                                                <b-form-input v-model="formData.section">
                                                </b-form-input>
<!--                                                <multiselect v-model="formData.section" :options="sectionOptions"-->
<!--                                                    :class="errors[0] ? 'box-border-color' : ''" label="text"-->
<!--                                                    track-by="value" :multiple="false" :select-label="''"-->
<!--                                                    :selected-label="''" :deselect-label="''" :placeholder="$t('select')"-->
<!--                                                    :searchable="true" >-->
<!--                                                </multiselect>-->
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"
                                                    class="mb-2"></b-form-invalid-feedback>
                                            </ValidationProvider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-group :label="$t('teaching_staff')">
                                            <ValidationProvider name="instructor_id" rules="required" v-slot="{ errors }">
                                                <staff-auto-complete v-model="formData.instructor_id"
                                                    :validate-error="errors[0]"></staff-auto-complete>
                                            </ValidationProvider>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group :label="$t('quota')">
                                            <ValidationProvider name="quota" rules="required" v-slot="{ errors }">
                                                <b-form-input v-model="formData.quota" type="number" min="0"
                                                    v-check-min-max-value max="9999" :state="errors[0] ? false : null">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"
                                                    class="mb-2"></b-form-invalid-feedback>
                                            </ValidationProvider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-form-group :label="$t('explanation')">
                                    <ValidationProvider name="explanation" v-slot="{ errors }">
                                        <b-form-textarea v-model="formData.explanation" rows="1"></b-form-textarea>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                            v-html="errors[0]"></b-form-invalid-feedback>
                                    </ValidationProvider>
                                </b-form-group>

                                <b-row v-if="course">
                                    <b-col cols="12">
                                        <b-form-group :label="$t('section_definition')">
                                            <ValidationProvider name="definition" rules="" v-slot="{ errors }">
                                                <b-input-group class="mb-1">
                                                    <b-form-input v-model="formData.definition"
                                                        :state="errors[0] ? false : null" />
                                                </b-input-group>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2" />
                                            </ValidationProvider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                            </div>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </b-col>
            <b-col cols="12" md="5">
                <label>{{ $t('Modalıty ') }}</label>
                <div class="border p-4 rounded-sm">
                    <ValidationObserver ref="courseDetailValidate">
                        <b-row>
                            <b-col>
                                <b-form-group label="Modality">
                                    <ValidationProvider name="type" rules="required" v-slot="{ errors }">
                                        <ParameterSelectbox v-model="courseWork.type"
                                                            code="section_processing_types"
                                                            :validate-error="errors[0]"
                                            :disabled="false"></ParameterSelectbox>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col md="2">
                                <label>&nbsp;</label>
                                <b-button variant="primary" @click="addCourseWorks" block
                                    :disabled="false">{{ $t('add') }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                    <b-table bordered striped :fields="courseWorkTableFields" :items="courseWorks"
                        v-if="courseWorks && courseWorks.length">
                        <template #cell(type)="data">
                            {{ $t(data.value) }}
                        </template>
                        <template #cell(delete)="data">
                            <div class="d-flex">
                                <b-button variant="danger" size="sm" @click="removeCourseWorks(data.index)">
                                    <i class="ri-close-line"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div v-if="formData.course_id" class="mt-3">
                    <label>{{ $t('program_detail_code') }}</label>
                    <div class="border p-4 rounded-sm">
                        <ValidationObserver ref="courseDetailValidate">
                            <b-row>
                                <b-col>
                                    <ValidationProvider name="program_code" rules="" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('program')">
                                            <program-selectbox v-model="formData.detail_code"
                                                               :course_id="formData.course_id"
                                                               :multiple="true"
                                                               :validate-error="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </ValidationObserver>
                        <b-table bordered striped :fields="courseWorkTableFields" :items="courseWorks"
                                 v-if="courseWorks && courseWorks.length">
                            <template #cell(type)="data">
                                {{ $t(data.value) }}
                            </template>
                            <template #cell(delete)="data">
                                <div class="d-flex">
                                    <b-button variant="danger" size="sm" @click="removeCourseWorks(data.index)">
                                        <i class="ri-close-line"></i>
                                    </b-button>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </b-col>
        </b-row>

        <div class="d-flex justify-content-center mt-3 mb-3">
            <b-button variant="primary" @click="createForm" />
        </div>
        <div v-if="sections && sections.length > 0">
            <b-table bordered striped hover :fields="sectionFields" :items="sections">
                <template #cell(type)="data">
                    {{ $t(data.value) == 1 ? $t('theoric') : $t('practical') }}
                </template>
                <template #cell(details)="data">
                    <div class="d-flex">
                        <b-button variant="primary" size="sm" @click="showDetail(data.item.id)">
                            {{ $t('detail').toUpper() }}
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>
        <!-- Detail Modal -->
        <CommonModal ref="detailModal" size="xxl" :onHideOnlyX="true">
            <template v-slot:CommonModalTitle>
                {{ $t('details') }}
            </template>
            <template v-slot:CommonModalContent>
                <detail-index :formId="selectedId" :key="selectedId">
                </detail-index>
            </template>
        </CommonModal>
    </div>
</template>

<script>
// Components
import CourseAutoComplete from '@/components/interactive-fields/CourseAutoComplete';
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';
import SemestersSelectbox from '@/components/interactive-fields/SemestersSelectbox';
import StaffAutoComplete from '@/components/interactive-fields/StaffAutoComplete';
import StatusSelectbox from '@/components/interactive-fields/StatusSelectbox';
import CommonModal from '@/components/elements/CommonModal';
import DetailIndex from './detail/Index'

// Other
import { ValidationObserver, ValidationProvider } from 'vee-validate'

// Services
import SectionService from '@/services/SectionService'
import CourseService from '@/services/CourseService';

export default {
    components: {
        CourseAutoComplete,
        ParameterSelectbox,
        SemestersSelectbox,
        StaffAutoComplete,
        StatusSelectbox,
        CommonModal,
        DetailIndex,
        ValidationProvider,
        ValidationObserver
    },
    props: {},
    data() {
        return {
            sectionFields: [
                {
                    key: 'course_id',
                    label: this.$t('course_id').toUpper(),
                    sortable: true
                },
                {
                    key: 'course_code',
                    label: this.$t('course_name').toUpper(),
                    sortable: true
                },
                {
                    key: 'course_name',
                    label: this.$t('course_name').toUpper(),
                    sortable: true
                },
                {
                    key: 'type',
                    label: this.$t('section_type').toUpper(),
                    sortable: true
                },
                {
                    key: 'section',
                    label: this.$t('section').toUpper(),
                    sortable: true
                },
                {
                    key: 'instructor_name',
                    label: this.$t('teaching_staff').toUpper(),
                    sortable: true
                },
                {
                    key: 'quota',
                    label: this.$t('quota').toUpper(),
                    sortable: true
                },
                {
                    key: 'details',
                    label: '',
                    thClass: 'text-center',
                    tdClass: 'text-center width-50'
                }
            ],
            sections: [],
            formData: {
                semester_id: null,
                course_id: null,
                status: null,
                type: null,
                section: null,
                instructor_id: null,
                quota: null,
                explanation: null,
                definition: null,
                theoretical_model: [],
                practical_model: []
            },
            courseWorks: [],
            courseWork: {
                type: null,
            },
            courseWorkTableFields: [
                {
                    key: 'type',
                    label: this.$t('processing_model').toUpper(),
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    key: 'delete',
                    label: '',
                    thClass: 'text-center',
                    tdClass: 'text-center width-50'
                }
            ],
            formProcess: false,
            sectionMin: 0,
            sectionMax: 0,
            sectionOptions: [
                {
                    value: null, text: this.$t('select')
                },
            ],
            selectedId: null,
            courseCredits: {
                teoric: null,
                pratic: null,
                credit: null,
                ects: null
            },
            course: null
        }
    },
    methods: {
        formDataClear() {
            this.formData = {
                semester_id: null,
                course_id: null
            }
            this.$refs.formModalValidate.reset();
        },

        setSectionMinMax() {
            this.formData.section = null
            this.sectionOptions = []

            for (let i = 1; i <= 999; i++) {
                    this.sectionOptions.push({ value: i, text: i })
                }
            this.getCourseCredits()

        },

        getCourseCredits() {
            if (this.formData.course_id != null) {
                CourseService.get(this.formData.course_id)
                    .then(response => {
                        let data = response.data.data
                    })
            }
        },

        getCourseCreditsForInfo(course_id) {
            if (course_id) {
                CourseService.get(course_id)
                    .then(response => {
                        let data = response.data.data
                        this.course = data;
                        this.courseCredits.credit = data.credit
                    })
            } else {
                this.courseCredits.credit = null
            }
        },

        // Create
        async addCourseWorks() {
            const isValid = await this.$refs.courseDetailValidate.validate();
            if (isValid ) {
                this.courseWorks.push({
                    ...this.courseWork
                })
            }
        },
        removeCourseWorks(index) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.courseWorks.splice(index, 1);
                    }
                });
        },

        // Create
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                let formData = {
                    ...this.formData,
                    'section': this.formData.section,
                    'status': 'a'
                }

                if (this.courseWorks && this.courseWorks.length) {
                    this.courseWorks.forEach(() => {
                        formData.theoretical_model = this.courseWorks;
                        // if (formData.type == 1) {
                        //     formData.theoretical_model = this.courseWorks;
                        // } else {
                        //     formData.practical_model = this.courseWorks;
                        // }
                    })
                }

                this.formProcess = true
                return SectionService.store(formData)
                    .then(response => {
                        this.sections.push(response.data.data);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate)
                    })
                    .finally(() => {
                        this.formProcess = false
                    })
            }
        },

        showDetail(id) {
            this.selectedId = id
            this.$refs.detailModal.$refs.commonModal.show();
        }
    },

    watch: {
        'formData.course_id': {
            handler: function (val) {
                this.getCourseCreditsForInfo(val)
            }
        }
    }
}
</script>

